import { render } from "./ClassDetails.vue?vue&type=template&id=0b23c69a&scoped=true&ts=true"
import script from "./ClassDetails.vue?vue&type=script&lang=ts"
export * from "./ClassDetails.vue?vue&type=script&lang=ts"

import "./ClassDetails.vue?vue&type=style&index=0&id=0b23c69a&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b23c69a"]])

export default __exports__